import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant", "label", "margin", "children", "fullWidth", "type", "multiline"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var TextField = function TextField(_ref) {
  var variant = _ref.variant,
    label = _ref.label,
    margin = _ref.margin,
    children = _ref.children,
    fullWidth = _ref.fullWidth,
    type = _ref.type,
    multiline = _ref.multiline,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(MuiTextField, _objectSpread(_objectSpread({
    label: label,
    fullWidth: fullWidth,
    margin: margin,
    variant: variant,
    type: type,
    multiline: multiline
  }, props), {}, {
    children: children
  }));
};
TextField.defaultProps = {
  margin: 'normal',
  fullWidth: true,
  variant: 'outlined',
  label: undefined,
  type: undefined,
  multiline: false,
  children: undefined
};
export default TextField;